import { makePublicUrl } from 'app/utils/publicUrl'
import SubscriptionInfo from '../../HomeStatus/SubInfo/SubscriptionInfo'
import { SubsDetailsPlanBlock, SubsDetailsPlanImage } from './styles'
import { SubscriptionPlanDetailsProps } from './types'

const homeDetailsImage = makePublicUrl('images/illustrations/homeDetails.svg')

function SubscriptionPlanDetails(props: SubscriptionPlanDetailsProps) {
  return (
    <SubsDetailsPlanBlock>
      <SubscriptionInfo
        isHomeDashboard={props.isHomeDashboard}
        isDetailsPage
        hasShowMore={props.hasShowMore}
      />
      <SubsDetailsPlanImage>
        <img src={homeDetailsImage} alt="" />
      </SubsDetailsPlanImage>
    </SubsDetailsPlanBlock>
  )
}

export default SubscriptionPlanDetails
